import React from 'react';
import snakeToCapitalize from '@utils/functions/snakeToCapitalize';
const keyPrefixes = ['is_'];
export default function fieldMarkedDetailStrategy() {
    return {
        appliesTo: (key) => key === 'is_resolved',
        render: (key, newValue) => {
            // For Create events, just show the active status
            const keyPrefix = keyPrefixes.find((prefix) => key.startsWith(prefix));
            const keyName = keyPrefix ? key.replace(keyPrefix, '') : key;
            const isMarked = Boolean(newValue);
            return isMarked ? (React.createElement("span", { key: key },
                "Marked as: ",
                React.createElement("b", null, snakeToCapitalize(keyName)))) : (React.createElement("span", { key: key },
                "Marked as: ",
                React.createElement("b", null,
                    "Un",
                    keyName)));
        }
    };
}
